export enum FLEET_CARD_APPLICATION_STATUS {
  INACTIVE = 'inactive',
  WAITLIST = 'waitlist',
  UPSELL = 'upsell',
  APPROVED = 'approved',
  BLOCKLISTED = 'blocklisted',
  APPLICATION_STARTED = 'application_started',
}
